import type { AccessPair } from '@/shared/lib'

/** `/v1/shipments/**` — своего права нет: клиенту `403`, менеджеру без `client` — `400 CLIENT_REQUIRED`. */
export const SHIPMENTS_ACCESS: AccessPair = { onBehalf: 'manager.orders.view' }
